
import request from '@/utils/request';

export function fetEnterpriseMessage(params) {
  return request({
    url: `/message-server/enterprises/${params.eid}/messages`,
    method: 'get',
    params: {
      page: params.page,
      pageSize: params.pageSize,
      status: params.status,
      resourceType: params.resourceType,
      resourceID: params.resourceID
    }
  });
}

export function handleEnterpriseMessage(params) {
  return request({
    url: `/message-server/enterprises/${params.eid}/messages/${params.messageID}`,
    method: 'put',
    data: {
      note: params.note,
      status: params.status
    }
  });
}

export function fetMarketMessage(params) {
  return request({
    url: `/message-server/markets/${params.marketID}/messages`,
    method: 'get',
    params: {
      page: params.page,
      pageSize: params.pageSize,
      status: params.status,
      resourceType: params.resourceType,
      resourceID: params.resourceID
    }
  });
}

export function handleMarketMessage(params) {
  return request({
    url: `/message-server/markets/${params.marketID}/messages/${params.messageID}`,
    method: 'put',
    data: {
      note: params.note,
      status: params.status
    }
  });
}

export function getOverviewAboutMessage(data) {
  return request({
    url: `/message-server/overview`,
    method: 'get'
  });
}
export function getUserOverviewAboutMessage(params) {
  return request({
    url: `/message-server/overview`,
    method: 'get',
    params: params
  });
}



// WEBPACK FOOTER //
// ./src/api/message.js